export default class EQProfTypes {
  static Dipendente = 1
  static CoCoCo = 2
  static LiberoProfessionista = 3
}
